import moment from "moment-timezone";

interface TimezoneOption {
  value: string;
  label: string;
  subtitle: string;
}

// Модульный кэш — вычисляем список опций один раз и переиспользуем при
// повторных вызовах (например, когда `options` передаётся как ссылка на
// функцию и вызывается заново при каждом рендере поля, либо при
// повторных re-evaluation модуля в HMR/тестах).
let cachedTimezoneOptions: TimezoneOption[] | null = null;

/**
 * Получает список опций для выбора таймзон — полный список IANA-зон из
 * moment-timezone, не ограниченный Россией.
 */
export const getTimezoneOptions = (): TimezoneOption[] => {
  if (cachedTimezoneOptions) {
    return cachedTimezoneOptions;
  }

  cachedTimezoneOptions = moment.tz
    .names()
    .map((timezone) => {
      const offset = moment.tz(timezone).format("Z");

      return {
        value: timezone,
        label: timezone, // Используем стандартное IANA название
        subtitle: `UTC${offset}`, // Добавляем subtitle с кратким UTC смещением
      };
    })
    .sort((a, b) => a.value.localeCompare(b.value));

  return cachedTimezoneOptions;
};

/**
 * Получает UTC смещение для таймзоны
 */
export const getTimezoneOffset = (timezone: string): string => {
  if (!timezone) return "+3";

  try {
    return moment.tz(timezone).format("Z");
  } catch {
    return "+3";
  }
};

/**
 * Форматирует таймзону для отображения
 */
export const formatTimezone = (timezone: string | null | undefined): string => {
  if (!timezone) return "UTC+3";

  try {
    const offset = moment.tz(timezone).format("Z");
    return `UTC${offset}`;
  } catch {
    return timezone;
  }
};

/**
 * Получает текущее время в указанной таймзоне
 */
export const getCurrentTimeInTimezone = (timezone: string): moment.Moment => {
  return moment().tz(timezone);
};
